module.exports = __webpack_public_path__ + "static/media/splitSections.6495d2d8.png";